module.exports = __webpack_public_path__ + "img/遊戲結束後介面_合成明信片_V2.0ae8c1cf.png";